// Content for the "<district> или Бистрица?" comparison landing pages.
// Each district page targets the "къща <district>" ad traffic and argues the
// Bistritsa case: sun (no Vitosha shade), quiet, new construction, clean air
// at 897 m, out of the city but 5 min from the ring road.

const compareLocations = {
	boyana: {
		slug: 'kashti-boyana',
		bg: {
			name: 'Бояна',
			title: 'Къща в Бояна или в Бистрица? Сравнение | Вкъщи',
			metaDescription:
				'Търсите къща в Бояна? Сравнете с Бистрица: слънце без сянката на Витоша, селска тишина, ново строителство и чист въздух на 897 м — на 5 минути от Околовръстното.',
			h1: 'Къща в Бояна или в Бистрица?',
			subtitle: 'Честно сравнение между два от най-търсените адреси под Витоша',
			intro:
				'Бояна е сред най-престижните квартали на София — и точно затова е плътно застроена, оживена и почти без свободни парцели. Ако търсите къща в Бояна, си струва да погледнете и 15 минути по-нагоре: Бистрица дава това, заради което човек всъщност напуска центъра — слънце, тишина и ново строителство — без да жертва достъпността.',
			rows: [
				{
					label: 'Слънце',
					other: 'Северното подножие на Витоша — зимата слънцето се скрива зад планината още следобед',
					bistritsa: 'Южните склонове, открито било на 897 м — слънце без планина, която да го закрива'
				},
				{
					label: 'Тишина',
					other: 'Плътна застройка и постоянен трафик към бул. „България“',
					bistritsa: 'Селска тишина от около 30 dB в края на улица без преходен трафик'
				},
				{
					label: 'Строителство',
					other: 'Почти без свободни парцели — предимно по-стар сграден фонд',
					bistritsa: 'Ново строителство — модерни къщи от последните години около комплекса'
				},
				{
					label: 'Въздух',
					other: 'Около 750 м — в обхвата на зимната смог инверсия',
					bistritsa: '897 м — над инверсията, чист въздух и зимата'
				},
				{
					label: 'Достъп',
					other: 'В града — заедно с градския трафик',
					bistritsa: 'Извън градската суматоха, но само на 5 минути от Околовръстното'
				}
			],
			whyParagraphs: [
				'Бояна лежи в северното подножие на Витоша: през зимата слънцето минава ниско зад планината и следобедите потъват в сянка рано. Бистрица е разположена по южните склонове, на открито било на 897 м — няма масив, който да закрива слънцето, а хоризонтът е 360°, с гледка над цяла София.',
				'Втората голяма разлика е средата: Бояна отдавна е част от града — с неговия трафик, плътна застройка и остарял сграден фонд. Бистрица е крачка извън града — селска тишина, ново строителство наоколо и планината на прага — и въпреки това Околовръстното е на 5 минути.'
			]
		},
		en: {
			name: 'Boyana',
			title: 'House in Boyana or in Bistritsa? A Comparison | Vkushty',
			metaDescription:
				'Looking for a house in Boyana, Sofia? Compare with Bistritsa: sunshine with no Vitosha shade, rural quiet, new construction and clean air at 897 m — 5 minutes from the ring road.',
			h1: 'A House in Boyana or in Bistritsa?',
			subtitle: 'An honest comparison of two of the most sought-after addresses below Vitosha',
			intro:
				'Boyana is one of Sofia\'s most prestigious districts — which is exactly why it is densely built, busy and nearly out of free plots. If you are looking for a house in Boyana, it is worth looking 15 minutes further up: Bistritsa offers what people actually leave the centre for — sun, quiet and new construction — without giving up accessibility.',
			rows: [
				{
					label: 'Sunshine',
					other: 'The northern foot of Vitosha — in winter the sun disappears behind the mountain by mid-afternoon',
					bistritsa: 'The southern slopes, an open ridge at 897 m — no mountain blocking the sun'
				},
				{
					label: 'Quiet',
					other: 'Dense construction and constant traffic towards Bulgaria Blvd',
					bistritsa: 'Rural quiet of around 30 dB at the end of a street with no through traffic'
				},
				{
					label: 'Housing stock',
					other: 'Nearly no free plots left — mostly older houses',
					bistritsa: 'New construction — contemporary houses built in recent years'
				},
				{
					label: 'Air',
					other: 'Around 750 m — within reach of the winter smog inversion',
					bistritsa: '897 m — above the inversion, clean air even in winter'
				},
				{
					label: 'Access',
					other: 'Inside the city — together with the city traffic',
					bistritsa: 'Out of the city bustle, yet only 5 minutes from the ring road'
				}
			],
			whyParagraphs: [
				'Boyana sits at the northern foot of Vitosha: in winter the sun passes low behind the mountain and the afternoons fall into shade early. Bistritsa lies on the southern slopes, on an open ridge at 897 m — no massif blocks the sun, and the horizon is a full 360° with a view over all of Sofia.',
				'The second big difference is the setting: Boyana has long been part of the city — with its traffic, dense construction and ageing housing stock. Bistritsa is a step outside the city — rural quiet, new houses around and the mountain at your doorstep — and yet the ring road is 5 minutes away.'
			]
		}
	},

	dragalevtsi: {
		slug: 'kashti-dragalevtsi',
		bg: {
			name: 'Драгалевци',
			title: 'Къща в Драгалевци или в Бистрица? Сравнение | Вкъщи',
			metaDescription:
				'Търсите къща в Драгалевци? Сравнете с Бистрица: повече слънце, по-малко трафик, ново строителство и въздух на 897 м — на 5 минути от Околовръстното.',
			h1: 'Къща в Драгалевци или в Бистрица?',
			subtitle: 'Двете витошки села — отблизо',
			intro:
				'Драгалевци отдавна не е село — кварталът е плътно застроен, улиците около центъра са тесни и натоварени, а свободни парцели почти няма. Бистрица е следващата спирка по планината — и е запазила точно това, което Драгалевци е загубил: пространство, тишина и ново строителство.',
			rows: [
				{
					label: 'Слънце',
					other: 'Северното подножие на Витоша — ранна следобедна сянка през зимата',
					bistritsa: 'Южните склонове, открито било на 897 м — слънце през целия ден'
				},
				{
					label: 'Тишина',
					other: 'Тесни улици, натоварен трафик към Черни връх и центъра на квартала',
					bistritsa: 'Селска тишина от около 30 dB, без преходен трафик'
				},
				{
					label: 'Строителство',
					other: 'Плътна застройка, смесен и застаряващ сграден фонд',
					bistritsa: 'Ново строителство — модерни къщи от последните години'
				},
				{
					label: 'Въздух',
					other: 'Около 800 м, но в градската среда',
					bistritsa: '897 м — над зимната инверсия, между Витоша и Плана'
				},
				{
					label: 'Достъп',
					other: 'През натоварените улици на квартала',
					bistritsa: 'Извън града, но на 5 минути от Околовръстното'
				}
			],
			whyParagraphs: [
				'Драгалевци и Бистрица тръгват от една и съща идея — къща в полите на Витоша. Разликата е в това докъде е стигнала урбанизацията: Драгалевци е погълнат от града, с плътна застройка и трафик, докато Бистрица остава село — с площад, тишина и звезди вечер.',
				'При това Бистрица е и по-високо, и по-огряно място: южните склонове на 897 м са над зимната смог инверсия и без планински масив, който да краде следобедното слънце. А Околовръстното е на същите 5 минути.'
			]
		},
		en: {
			name: 'Dragalevtsi',
			title: 'House in Dragalevtsi or in Bistritsa? A Comparison | Vkushty',
			metaDescription:
				'Looking for a house in Dragalevtsi, Sofia? Compare with Bistritsa: more sunshine, less traffic, new construction and clean air at 897 m — 5 minutes from the ring road.',
			h1: 'A House in Dragalevtsi or in Bistritsa?',
			subtitle: 'The two Vitosha villages, up close',
			intro:
				'Dragalevtsi stopped being a village long ago — the district is densely built, the streets around its centre are narrow and busy, and free plots are nearly gone. Bistritsa is the next stop along the mountain — and it has kept exactly what Dragalevtsi lost: space, quiet and new construction.',
			rows: [
				{
					label: 'Sunshine',
					other: 'The northern foot of Vitosha — early afternoon shade in winter',
					bistritsa: 'The southern slopes, an open ridge at 897 m — sun all day'
				},
				{
					label: 'Quiet',
					other: 'Narrow streets and heavy traffic towards Cherni Vrah Blvd',
					bistritsa: 'Rural quiet of around 30 dB, no through traffic'
				},
				{
					label: 'Housing stock',
					other: 'Dense construction, mixed and ageing housing',
					bistritsa: 'New construction — contemporary houses from recent years'
				},
				{
					label: 'Air',
					other: 'Around 800 m, but in an urban setting',
					bistritsa: '897 m — above the winter inversion, between Vitosha and Plana'
				},
				{
					label: 'Access',
					other: 'Through the district\'s congested streets',
					bistritsa: 'Outside the city, yet 5 minutes from the ring road'
				}
			],
			whyParagraphs: [
				'Dragalevtsi and Bistritsa start from the same idea — a house at the foot of Vitosha. The difference is how far urbanisation has gone: Dragalevtsi has been absorbed by the city, with dense construction and traffic, while Bistritsa remains a village — with a square, quiet, and stars in the evening.',
				'Bistritsa is also higher and sunnier: the southern slopes at 897 m sit above the winter smog inversion, with no massif stealing the afternoon sun. And the ring road is the same 5 minutes away.'
			]
		}
	},

	simeonovo: {
		slug: 'kashti-simeonovo',
		bg: {
			name: 'Симеоново',
			title: 'Къща в Симеоново или в Бистрица? Сравнение | Вкъщи',
			metaDescription:
				'Търсите къща в Симеоново? Сравнете с Бистрица: слънце без сянката на Витоша, тишина без Симеоновско шосе, ново строителство и въздух на 897 м.',
			h1: 'Къща в Симеоново или в Бистрица?',
			subtitle: 'Съседи по планината, различни като среда',
			intro:
				'Симеоново привлича с лифта и близостта до Витоша, но плаща за това с натоварено Симеоновско шосе, плътна нова застройка и уикенд поток към планината. Бистрица е на десет минути източно — със същата планина, но без потока: тихо село на открито било с гледка над цяла София.',
			rows: [
				{
					label: 'Слънце',
					other: 'Северното подножие на Витоша — планината закрива зимното следобедно слънце',
					bistritsa: 'Южните склонове, открито било на 897 м — слънце от сутрин до вечер'
				},
				{
					label: 'Тишина',
					other: 'Симеоновско шосе и уикенд трафикът към лифта',
					bistritsa: 'Селска тишина от около 30 dB, встрани от туристическите потоци'
				},
				{
					label: 'Строителство',
					other: 'Плътна и хаотична нова застройка между стари къщи',
					bistritsa: 'Ново строителство в порядъчна селска среда'
				},
				{
					label: 'Въздух',
					other: 'Около 750 м — в края на градската инверсия',
					bistritsa: '897 м — над инверсията, чист въздух и зимата'
				},
				{
					label: 'Достъп',
					other: 'През натовареното Симеоновско шосе',
					bistritsa: '5 минути от Околовръстното, без задръствания по пътя'
				}
			],
			whyParagraphs: [
				'Симеоново и Бистрица делят една планина, но не и една среда. Симеоново е входна точка към Витоша — с лифта идват колите, а с близостта до града — плътната застройка. Бистрица е встрани от туристическия поток: планината е същата, тишината — несравнима.',
				'Добавете и физическата география: Бистрица е по южните склонове на 897 м — над зимната смог инверсия и без масив, който да закрива следобедното слънце. Затова и най-скъпите имоти в страната са именно тук.'
			]
		},
		en: {
			name: 'Simeonovo',
			title: 'House in Simeonovo or in Bistritsa? A Comparison | Vkushty',
			metaDescription:
				'Looking for a house in Simeonovo, Sofia? Compare with Bistritsa: sunshine without the Vitosha shade, quiet without Simeonovsko Shose, new construction and clean air at 897 m.',
			h1: 'A House in Simeonovo or in Bistritsa?',
			subtitle: 'Neighbours on the mountain, worlds apart as a setting',
			intro:
				'Simeonovo attracts with the lift and the closeness of Vitosha, but pays for it with the busy Simeonovsko Shose, dense new construction and the weekend flow to the mountain. Bistritsa is ten minutes east — same mountain, none of the flow: a quiet village on an open ridge with a view over all of Sofia.',
			rows: [
				{
					label: 'Sunshine',
					other: 'The northern foot of Vitosha — the mountain blocks the winter afternoon sun',
					bistritsa: 'The southern slopes, an open ridge at 897 m — sun from morning to evening'
				},
				{
					label: 'Quiet',
					other: 'Simeonovsko Shose and the weekend traffic to the lift',
					bistritsa: 'Rural quiet of around 30 dB, away from the tourist flows'
				},
				{
					label: 'Housing stock',
					other: 'Dense, chaotic new construction between old houses',
					bistritsa: 'New construction in an orderly village setting'
				},
				{
					label: 'Air',
					other: 'Around 750 m — at the edge of the city inversion',
					bistritsa: '897 m — above the inversion, clean air even in winter'
				},
				{
					label: 'Access',
					other: 'Via the congested Simeonovsko Shose',
					bistritsa: '5 minutes from the ring road, no jams on the way'
				}
			],
			whyParagraphs: [
				'Simeonovo and Bistritsa share a mountain, but not a setting. Simeonovo is a gateway to Vitosha — the lift brings the cars, and the closeness to the city brings the dense construction. Bistritsa sits aside from the tourist flow: the mountain is the same, the quiet is incomparable.',
				'Add the physical geography: Bistritsa lies on the southern slopes at 897 m — above the winter smog inversion and with no massif blocking the afternoon sun. Which is why the most expensive properties in the country are exactly here.'
			]
		}
	},

	pancharevo: {
		slug: 'kashti-pancharevo',
		bg: {
			name: 'Панчарево',
			title: 'Къща в Панчарево или в Бистрица? Сравнение | Вкъщи',
			metaDescription:
				'Търсите къща в Панчарево? Сравнете с Бистрица: 270 м по-високо, над мъглите край езерото, встрани от Самоковско шосе — ново строителство и слънце на 897 м.',
			h1: 'Къща в Панчарево или в Бистрица?',
			subtitle: 'Езерото или билото — какво печелите с височината',
			intro:
				'Панчарево има езерото — и котловината около него: по-чести мъгли, повече влага и натовареното Самоковско шосе по протежение на квартала. Бистрица е на десет минути и 270 метра по-нагоре: на открито слънчево било, над мъглите и встрани от главния път. А езерото си остава на десет минути.',
			rows: [
				{
					label: 'Слънце',
					other: 'Котловина край езерото — по-чести мъгли и влага, особено наесен и зимата',
					bistritsa: 'Открито било на 897 м — над мъглите, слънце през целия ден'
				},
				{
					label: 'Тишина',
					other: 'Самоковско шосе минава през квартала',
					bistritsa: 'Селска тишина от около 30 dB, встрани от главните пътища'
				},
				{
					label: 'Строителство',
					other: 'Разнороден сграден фонд — от вили до стари къщи',
					bistritsa: 'Ново строителство — модерни къщи от последните години'
				},
				{
					label: 'Въздух',
					other: 'Около 620 м — в обхвата на инверсията и езерната влага',
					bistritsa: '897 м — над зимната инверсия, сух планински въздух'
				},
				{
					label: 'Достъп',
					other: 'По Самоковско шосе, с неговия трафик',
					bistritsa: '5 минути от Околовръстното по спокоен път'
				}
			],
			whyParagraphs: [
				'Панчарево залага на езерото, но живее в котловината му: влага, по-чести мъгли и главен път през квартала. Бистрица взима другата страна на сделката — 270 метра по-нагоре, на открито било със слънце и сух въздух, а до езерото се стига за десет минути, когато ви се иска.',
				'На 897 м Бистрица е над зимната смог инверсия, застроена е с нови къщи и е пазила селския си характер — тишина, площад, планина на прага. И пак сте на 5 минути от Околовръстното.'
			]
		},
		en: {
			name: 'Pancharevo',
			title: 'House in Pancharevo or in Bistritsa? A Comparison | Vkushty',
			metaDescription:
				'Looking for a house in Pancharevo, Sofia? Compare with Bistritsa: 270 m higher, above the lake fog, away from Samokovsko Shose — new construction and sunshine at 897 m.',
			h1: 'A House in Pancharevo or in Bistritsa?',
			subtitle: 'The lake or the ridge — what altitude buys you',
			intro:
				'Pancharevo has the lake — and the hollow around it: more frequent fog, more humidity, and the busy Samokovsko Shose running the length of the district. Bistritsa is ten minutes and 270 metres higher: on an open sunny ridge, above the fog and away from the main road. And the lake stays ten minutes away.',
			rows: [
				{
					label: 'Sunshine',
					other: 'A hollow by the lake — more frequent fog and humidity, especially in autumn and winter',
					bistritsa: 'An open ridge at 897 m — above the fog, sun all day'
				},
				{
					label: 'Quiet',
					other: 'Samokovsko Shose runs through the district',
					bistritsa: 'Rural quiet of around 30 dB, away from the main roads'
				},
				{
					label: 'Housing stock',
					other: 'Mixed housing — from summer villas to old houses',
					bistritsa: 'New construction — contemporary houses from recent years'
				},
				{
					label: 'Air',
					other: 'Around 620 m — within the inversion and the lake humidity',
					bistritsa: '897 m — above the winter inversion, dry mountain air'
				},
				{
					label: 'Access',
					other: 'Along Samokovsko Shose, with its traffic',
					bistritsa: '5 minutes from the ring road on a calm route'
				}
			],
			whyParagraphs: [
				'Pancharevo bets on the lake but lives in its hollow: humidity, more frequent fog and a main road through the district. Bistritsa takes the other side of the deal — 270 metres higher, on an open ridge with sun and dry air, with the lake ten minutes away whenever you want it.',
				'At 897 m, Bistritsa sits above the winter smog inversion, is built up with new houses, and has kept its village character — quiet, a square, the mountain at the doorstep. And you are still 5 minutes from the ring road.'
			]
		}
	},

	kambanite: {
		slug: 'kashti-kambanite',
		bg: {
			name: 'Камбаните',
			title: 'Къща до Камбаните или в Бистрица? Сравнение | Вкъщи',
			metaDescription:
				'Гледате имот в района на Камбаните? Сравнете с Бистрица: тишина вместо Околовръстното под прозореца, къщи вместо комплекси, и въздух на 897 м.',
			h1: 'Къща до Камбаните или в Бистрица?',
			subtitle: 'До Бизнес парка или над града — два различни живота',
			intro:
				'Районът на Камбаните расте бързо заради Бизнес парка и Околовръстното — но точно те му остават под прозореца: трафик, шум и апартаментни комплекси един до друг. Бистрица е на пет минути по-нагоре и на друга планета: тихо село на 897 м, самостоятелни къщи и гледка над целия град.',
			rows: [
				{
					label: 'Тишина',
					other: 'Околовръстното и трафикът към Бизнес парка — постоянен фонов шум',
					bistritsa: 'Селска тишина от около 30 dB, далеч от големите пътища'
				},
				{
					label: 'Строителство',
					other: 'Гъсто разположени апартаментни комплекси в строеж',
					bistritsa: 'Самостоятелни къщи върху собствени парцели от 920-980 кв.м'
				},
				{
					label: 'Въздух',
					other: 'Около 680 м — в обхвата на зимната инверсия',
					bistritsa: '897 м — над инверсията, чист планински въздух'
				},
				{
					label: 'Среда',
					other: 'Нов район без изградена собствена среда',
					bistritsa: 'Село с площад, история и планината на прага'
				},
				{
					label: 'Достъп',
					other: 'До Околовръстното — буквално',
					bistritsa: '5 минути от Околовръстното — достатъчно близо, достатъчно далеч'
				}
			],
			whyParagraphs: [
				'Камбаните е удобен адрес за работещите в Бизнес парка, но е район, изграден около инфраструктура: Околовръстното е под прозореца, а средата тепърва се строи — предимно на височина, комплекс до комплекс. Бистрица предлага обратното: самостоятелна къща върху собствен парцел, в село със завършена среда.',
				'Петте минути нагоре по пътя купуват 200 метра височина: 897 м значи въздух над зимната смог инверсия, тишина от около 30 dB и открито било със слънце и 360° гледка — при същия достъп до Околовръстното и Бизнес парка.'
			]
		},
		en: {
			name: 'Kambanite',
			title: 'House near Kambanite or in Bistritsa? A Comparison | Vkushty',
			metaDescription:
				'Considering a property near Kambanite, Sofia? Compare with Bistritsa: quiet instead of the ring road under your window, houses instead of complexes, and clean air at 897 m.',
			h1: 'A House near Kambanite or in Bistritsa?',
			subtitle: 'Next to the Business Park or above the city — two different lives',
			intro:
				'The Kambanite area is growing fast thanks to the Business Park and the ring road — but those stay under its windows: traffic, noise and apartment complexes side by side. Bistritsa is five minutes further up and on another planet: a quiet village at 897 m, detached houses and a view over the whole city.',
			rows: [
				{
					label: 'Quiet',
					other: 'The ring road and Business Park traffic — constant background noise',
					bistritsa: 'Rural quiet of around 30 dB, away from the big roads'
				},
				{
					label: 'Housing stock',
					other: 'Densely packed apartment complexes under construction',
					bistritsa: 'Detached houses on private plots of 920-980 sq.m'
				},
				{
					label: 'Air',
					other: 'Around 680 m — within the winter inversion',
					bistritsa: '897 m — above the inversion, clean mountain air'
				},
				{
					label: 'Setting',
					other: 'A new area without an established environment of its own',
					bistritsa: 'A village with a square, history and the mountain at the doorstep'
				},
				{
					label: 'Access',
					other: 'Right at the ring road — literally',
					bistritsa: '5 minutes from the ring road — close enough, far enough'
				}
			],
			whyParagraphs: [
				'Kambanite is a convenient address for Business Park commuters, but it is an area built around infrastructure: the ring road is under the window, and the environment is still being built — mostly vertical, complex after complex. Bistritsa offers the opposite: a detached house on its own plot, in a village with a finished setting.',
				'The five minutes up the road buy 200 metres of altitude: 897 m means air above the winter smog inversion, quiet of around 30 dB and an open ridge with sun and a 360° view — with the same access to the ring road and the Business Park.'
			]
		}
	}
};

export default compareLocations;
